import React from 'react';

// Update these strings when you send the final wording.
export const homeText = {
  heroEyebrow: 'Bismillah',
  heroTitle: (
    <>
      Welcome to <span className="gold">Masjid Annoor</span> Wichita
    </>
  ),
  heroSubtitle:
    'A sanctuary of serenity and reflection, Masjid Annoor is more than just a place of worship—it is a home filled with faith, warmth, and tradition.',
};
